import React, { FC } from 'react'
import { Typography } from 'transfix-ui/core'
import { IBidApprovalStateEnum } from 'types/graphqlTypes'
import { DISPLAY } from 'constants/display'

interface BidApprovalStateProps {
  approvalState: IBidApprovalStateEnum
  dataTest?: string
}

export const formatApprovalState = (approvalState?: IBidApprovalStateEnum) => {
  switch (approvalState) {
    case IBidApprovalStateEnum.approved:
      return 'Approved'
    case IBidApprovalStateEnum.declined:
      return 'Rejected'
    case IBidApprovalStateEnum.open:
      return 'Pending Approval'
    default:
      return DISPLAY.empty
  }
}

export const BidApprovalStateText: FC<BidApprovalStateProps> = ({ approvalState, dataTest }) => {
  return (
    <Typography
      data-test={dataTest}
      variant='body1'
      color={approvalState === IBidApprovalStateEnum.approved ? 'textPrimary' : 'textSecondary'}>
      {formatApprovalState(approvalState)}
    </Typography>
  )
}

export default BidApprovalStateText
